import React from "react";

import styled from "styled-components";
import { ToastContainer, Slide } from "react-toastify";

import { colors, transition, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import iconClose from "../../../assets/images/icons/cross.svg";

import "react-toastify/dist/ReactToastify.css";

const StyledToastContainer = styled((props) => <ToastContainer {...props} />).attrs(() => ({
  className: "toast-container",
  toastClassName: "toast",
  bodyClassName: "body",
  progressClassName: "progress",

  hideProgressBar: true,
  position: "bottom-left",
  autoClose: 4000,
  transition: Slide,
  pauseOnFocusLoss: false,
}))`
  /* .toast-container */
  .Toastify__toast--success {
    background-color: ${colors.warning};
  }
  .Toastify__toast--error {
    background-color: ${colors.peach};
  }
  .Toastify__toast-body {
    white-space: pre-wrap;
    background: url("${iconClose}") no-repeat;
    background-position: bottom 50% right 10px;
    padding-right: 35px;
    background-size: 15px;
  }
  .Toastify__toast--info {
    background-color: ${colors.warning};
  }
  .Toastify__close-button {
    display: none; /* default "x" is hidden, since GPD cross icon is used in .Toastify__toast-body. */
  }
  .toast {
    transition: ${transition.baseTransition} !important;
    color: ${colors.black};
    font-size: 12px;
    font-family: ${fonts.fontBauRegular};
  }
  button[aria-label="close"] {
    color: ${colors.black};
  }
  ${breakpoints.xsUp} {
    width: 390px !important;
  }
  /* Position above the home-indicator inset and, on native, above the
   * tab bar. NativeTabBar publishes its current footprint as
   * --native-tab-bar-height on :root (0px when hidden — auth flow,
   * quiz, keyboard up, web, Suspense window). 1em of breathing room is
   * comfortable both for "above the bar" and "above the screen edge". */
  &.Toastify__toast-container--bottom-left,
  &.Toastify__toast-container--bottom-right,
  &.Toastify__toast-container--bottom-center {
    bottom: calc(var(--native-tab-bar-height, 0px) + env(safe-area-inset-bottom) + 1em);
  }
`;

// Re-export GlobalAlert from its own module for backwards compatibility.
// Consumers should prefer importing from ./GlobalAlert directly.
export { default as GlobalAlert } from "./GlobalAlert";
export { StyledToastContainer };
